import { observer } from 'mobx-react';
import { SyntheticEvent, useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import SlidingPanel from 'react-sliding-side-panel';
import noMessageIcon from '../../assets/Images/no-userLogs.png';
import userSettingEnum from '../../constants/enums/user-setting-enum';
import { GridRemoteConstant } from '../../constants/grid-constant';
import { useStore } from '../../contexts/store-provider';
import {
  UserLogsDefaultSortColumnOrder,
  UserLogsFilterInitialState,
} from '../../core/initialState/filter-initial-state';
import IPageInfo, { IPageLimitInfo } from '../../models/ICommon';
import IDefaultColumSortOrder from '../../models/IDefaultColumSortOrder';
import Grid from '../../shared-components/Grid/Grid';
import Pagination from '../../shared-components/Grid/Pagination';
import FilterPopupHOC from '../../shared-components/hoc/filter-popup-hoc/filter-popup-hoc';
import {
  CloseSidePanelIcon,
  RefreshIcon,
} from '../../shared-components/svgs/svgs';
import { formatMessage } from '../../translations/format-message';
import './user-logs.css';
import UserLogDetails from './users-log-details';
import FilterComponent from './components/filter';
import { IUserLogsFilter } from '../../models/IUserLogsFilter';
import Header from '../../shared-components/header/header';
import { getTenantIdFromLocalStorage } from '../../helpers/localstorage-helper';
import FormLoader from '../../shared-components/FormLoader/FormLoader';
import { DIDAdminModuleOptions, FactoryAdminModuleOptions } from '../../constants/options.constant';

const UserLogs = (props: any) => {
  const { userLogsStore, preferencesStore, factoryStore } = useStore();
  const {
    allProcess,
    userLogList,
    GetUserLogsListService,
    getAllUserLogsState,
    reset,
  } = userLogsStore;

  const {
    userSetting,
    setUserSetting,
    language,
    islanguageChanged,
    updateLanguageChangedFlag,
  } = preferencesStore;

  const { allAvailableFactories, GetAllFactoriesService, getAllFactoryState } =
    factoryStore;

  let lang: string;
  const allProcessListData = allProcess;
  const isFirstLoad = useRef(true);
  const [disablePagination, setDisablePagination] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [openPanel, setOpenPanel] = useState(false);
  const [isFilterCleared, setIsFilterCleared] = useState(true);
  const [columSortOrder, setColumnSortOrder] = useState<IDefaultColumSortOrder>(
    UserLogsDefaultSortColumnOrder
  );
  const [filterObj, setFilterObj] = useState<IUserLogsFilter>(
    UserLogsFilterInitialState
  );
  const [isFilterApplied, setIsFilterApplied] = useState<boolean>(false);
  const pageLimitOptions: Array<number> = [10, 20, 50, 100];

  const [pageLimitInfo, setPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.pageLimitConfig,
    isPageLimitChange: false,
  });

  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false,
  });

  const onPageChanged = (pageNumber: number) => {
    closePanelHandler();
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
  };

  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  };

  const onPageLimitChanged = (evt: any) => {
    let pages: number;
    pages = props.data && Math.ceil(props.data.length / evt.target.value);
    setPageInfo({
      ...pageInfo,
      currentPage: 1,
      totalPages: pages,
      isPagerChange: false,
    });
    setPageLimit({
      pageLimit: parseInt(evt.target.value),
      isPageLimitChange: true,
    });
    setUserSetting(userSettingEnum.UserLimitConfig, parseInt(evt.target.value));
  };

  const getProcessListServiceHandler = (
    userLogs?: IUserLogsFilter,
    isFilter = false
  ) => {
    const tenantId = getTenantIdFromLocalStorage();

    const logsFilter: IUserLogsFilter =
      tenantId === '-1'
        ? {
            ...(userLogs ?? filterObj),
            Column: columSortOrder.dataField,
            Order: columSortOrder.order,
          }
        : {
            ...(userLogs ?? filterObj),
            Factory:
              allAvailableFactories.find((fac) => fac.id === Number(tenantId))
                ?.value || '',
            Column: columSortOrder.dataField,
            Order: columSortOrder.order,
          };

    GetUserLogsListService({
      PagingDetails: {
        CurrentPage: pageInfo.currentPage,
        PageSize: pageLimitInfo.pageLimit,
        TotalPages: 0,
        TotalRecords: 0,
      },
      LogsFilter: logsFilter,
    });
  };

  useEffect(() => {
    reset();
    GetAllFactoriesService();
  }, []);

  useEffect(() => {
    getProcessListServiceHandler();
  }, [allAvailableFactories]);

  useEffect(() => {
    if (islanguageChanged) {
      updateLanguageChangedFlag();
    }
  }, [islanguageChanged]);
  useEffect(() => {
    setPageInfo({
      ...pageInfo,
      currentPage: userLogList?.PagingDetails.CurrentPage,
      totalPages: userLogList?.PagingDetails?.TotalPages,
      isPagerChange: false,
    });
    setDisablePagination(false);
  }, [userLogList]);
  // useEffect(() => {
  //   setPageInfo({
  //     ...pageInfo,
  //     totalPages: processList?.PagingDetails?.TotalPages,
  //     isPagerChange: false,
  //   });
  //   setDisablePagination(false);
  // }, [processList]);

  useEffect(() => {
    if (pageInfo.isPagerChange) {
      getProcessListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfo.currentPage]);

  useEffect(() => {
    if (pageLimitInfo.isPageLimitChange) {
      getProcessListServiceHandler();
      setPageLimit({ ...pageLimitInfo, isPageLimitChange: false });
    }
  }, [pageLimitInfo.pageLimit]);

  useEffect(() => {
    if (lang && language !== lang) {
      getProcessListServiceHandler();
    }
  }, [language]);

  //   useEffect(() => {
  //     if (addUpdateProcessState.success) {
  //       resetAddUpdateProcessState();
  //       getProcessListServiceHandler();
  //     }
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  //   }, [addUpdateProcessState.success]);

  //   useEffect(() => {
  //     if (deleteProcessState.success) {
  //       toast.success(formatMessage('deleted_success'));
  //       props.deletePopupToggleHandler();
  //       resetDeleteProcess();
  //       getProcessListServiceHandler();
  //     }
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  //   }, [deleteProcessState.success]);

  function rowClassFormat(row: any, rowId: number) {
    let className: string = '';
    if (selectedRow?.Id && row.Id === selectedRow.Id) {
      className = 'bg-row SelectedRow';
    }
    return className;
  }

  const rowEvents = (e: SyntheticEvent, row: any) => {
    //GetProcessByIdService(row.Id);
    setSelectedRow(row);
    if (selectedRow.Id === undefined || selectedRow.Id !== row.Id) {
      setOpenPanel(true);
    } else {
      setOpenPanel(!openPanel);
    }
  };

  const closePanelHandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
  };

  const refreshClickHandler = () => {
    getProcessListServiceHandler();
    closePanelHandler();
  };

  //   const deleteHandler = () => {
  //     DeleteProcessService(selectedId);
  //   };

  const createQueryString = (filter: IUserLogsFilter): string => {
    return Object.entries(filter)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join('#');
  };

  const filterHandler = (object: IUserLogsFilter) => {
    const filters =
      getTenantIdFromLocalStorage() === '-1'
        ? {
            ...object,
            Column: columSortOrder.dataField,
            Order: columSortOrder.order,
          }
        : {
            ...object,
            Factory:
              allAvailableFactories.find(
                (fac) => fac.id === Number(getTenantIdFromLocalStorage())
              )?.value || '',
            Column: columSortOrder.dataField,
            Order: columSortOrder.order,
          };
    //const filter = createQueryString({ ...filters });
    getProcessListServiceHandler(filters, true);
    setFilterObj({ ...filters });
    props.filterPopupToggleHandler();
    closePanelhandler();
    setIsFilterCleared(false);
  };

  const closePanelhandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
  };

  const filterParams = (obj: IUserLogsFilter, isfilterCleard: boolean) => {
    const filter =
      getTenantIdFromLocalStorage() === '-1'
        ? {
            ...obj,
            Factory: obj.Factory === '-1' ? '' : obj.Factory,
            Column: columSortOrder.dataField,
            Order: columSortOrder.order,
          }
        : {
            ...obj,
            Factory:
              allAvailableFactories.find(
                (fac) => fac.id === Number(getTenantIdFromLocalStorage())
              )?.value || '',
            Column: columSortOrder.dataField,
            Order: columSortOrder.order,
          };

    if (isfilterCleard) {
      setFilterObj({ ...obj });
      getProcessListServiceHandler(filter);
      closePanelhandler();
      setIsFilterCleared(true);
    } else {
      setFilterObj({ ...obj });
    }
    props.filterPopupToggleHandler();
  };

  const handleTableChange = (type: any, newState: any) => {
    if (isFirstLoad.current) {
      isFirstLoad.current = false;
      return;
    }

    setColumnSortOrder((prevState) => ({
      ...prevState,
      dataField: newState.sortField,
      order: newState.sortOrder,
    }));
  };

  // useEffect(() => {
  //   const filter ={
  //     ...filterObj,
  //     Column: columSortOrder.dataField,
  //     Order: columSortOrder.order,
  //   };
  //   getProcessListServiceHandler(filter);
  // }, [columSortOrder]);

  const columns: any = [
    {
      dataField: 'serialNumber',
      text: formatMessage('serial_number'),
      classes: 'show-Elipses',
      isDummyField: true,
      formatter: (_: any, __: any, rowIndex: number) => rowIndex + 1,
      sort: false,
    },
    {
      dataField: 'Id',
      text: formatMessage('label_id'),
      classes: 'show-Elipses',
      hidden: true,
    },
    {
      dataField: 'Factory',
      text: formatMessage('factory_name'),
      classes: 'show-Elipses',
      sort: false,
    },

    {
      dataField: 'UserName',
      text: formatMessage('user_name'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell?.length > 10 ? cell : undefined;
      },
      sort: false,
    },
    {
      dataField: 'ActionDetail',
      text: formatMessage('key_field'),
      sort: false,
      classes: 'show-Elipses',
      // title: (cell: string) => {
      //   return cell.length > 10 ? cell : undefined;
      // },
    },
    {
      dataField: 'Action',
      text: formatMessage('event'),
      sort: false,
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      formatter: (cell: string) => {
        return <FormattedMessage id={cell.toLowerCase()} />;
      },
    },
    {
      dataField: 'Module',
      text: formatMessage('module'),
      sort: false,
      classes: 'show-Elipses',
      formatter: (cell: string) => {
        return <FormattedMessage id={cell} />;
      },
    },
    {
      dataField: 'ActionDateTime',
      text: formatMessage('date_time'),
      classes: 'show-Elipses',
    },
  ];

  return (
    <>
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row align-items-center">
          {getTenantIdFromLocalStorage() === '-1' ? (
            <div className="col-md-6 col-12">
              <div className="page_title_wrap">
                <h1 className="page_title">
                  <FormattedMessage id="user_logs" />
                </h1>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <FormattedMessage id="home" />
                  </li>
                  <li
                    className="breadcrumb-item active"
                    aria-current="page"
                  >
                    <FormattedMessage id="user_logs" />
                  </li>
                </ol>
              </div>
            </div>
          ) : (
            <Header
              className="col-md-6 col-12"
              label="user_logs"
            />
          )}
          {/* <Header
            className="col-lg-6 col-md-6 col-sm-6"
            label="user_logs"
          /> */}
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="add-list">
              <li>
                <FilterComponent
                  initialValues={{
                    ...filterObj,
                    Factory:
                      getTenantIdFromLocalStorage() !== '-1'
                        ? Number(getTenantIdFromLocalStorage())
                        : filterObj.Factory === '-1'
                          ? -1
                          : allAvailableFactories.find(
                              (item) => item.value === filterObj.Factory
                            )?.id || -1,
                  }}
                  id={0}
                  submitHandler={filterHandler}
                  filterParmas={filterParams}
                  onModalClosed={props.filterPopupToggleHandler}
                  isFilterCleared={isFilterCleared}
                  isLoading={false}
                  isDisable={false}
                  isFilterApplied={isFilterApplied}
                  setIsFilterApplied={setIsFilterApplied}
                  tenantBlankOptions={allAvailableFactories}
                  moduleOptions={Number(getTenantIdFromLocalStorage()) === -1 ? DIDAdminModuleOptions : FactoryAdminModuleOptions}
                />
              </li>
              <li title={formatMessage('refresh')}>
                <a
                  data-toggle="modal"
                  className="btn btn-light"
                  onClick={() => refreshClickHandler()}
                >
                  <RefreshIcon />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className={`${openPanel ? 'panelOpen' : ''}`}>
        <div className="card card-page">
          {(getAllUserLogsState.inProgress ||
            getAllFactoryState.inProgress) && (
            <FormLoader
              loading={
                getAllUserLogsState.inProgress || getAllFactoryState.inProgress
              }
            />
          )}
          {allProcessListData && allProcessListData.length > 0 ? (
            <>
              <div>
                <div className="tableDesign row-eq-height tableDevices p-3 changingPanel">
                  <div
                    className="table-responsive"
                    data-testid="table"
                  >
                    {allProcessListData && (
                      <Grid
                        data={allProcessListData}
                        columns={columns}
                        keyField="Id"
                        loading={false}
                        rowClasses={rowClassFormat}
                        rowEvents={{ onClick: rowEvents }}
                        hover={true}
                        sort={{ ...columSortOrder }}
                        remote={{ ...GridRemoteConstant }}
                        onTableChange={handleTableChange}
                      />
                    )}
                  </div>
                </div>
              </div>
              {allProcessListData.length > 0 ? (
                <div className="row no-gutters p-3 pt-0 tableFooter">
                  <div className="col-lg-3 col-md-6 col-sm-6 pt-1">
                    <FormattedMessage id="show" />
                    <select
                      data-testid="pageSelect"
                      className="pageLimit"
                      onChange={onPageLimitChanged}
                      value={pageLimitInfo.pageLimit}
                    >
                      {pageLimitOptions.map((op: any) => (
                        <option
                          key={op}
                          value={op}
                        >
                          {op}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-9 col-md-6 col-sm-6 d-flex justify-content-sm-end">
                    <Pagination
                      isRefreshPage={false}
                      totalPages={pageInfo.totalPages}
                      pageLimit={pageLimitInfo.pageLimit}
                      onPageChanged={onPageChanged}
                      disablePagination={disablePagination}
                      setIsRefreshPage={setIsRefreshPage}
                      currentPage={pageInfo.currentPage}
                      totalRecords={userLogList.PagingDetails.TotalRecords}
                    />
                  </div>
                </div>
              ) : (
                ''
              )}
            </>
          ) : (
            <div className="message">
              <div className="d-flex message-area">
                <div className="no-data-img">
                  <img
                    src={noMessageIcon}
                    alt=""
                    className="no_message"
                  />
                </div>
                <div>
                  <h3 className="fw-bold display-6">
                    {' '}
                    <FormattedMessage id="no_logs" />
                  </h3>
                  <h4 className="mb-3">{formatMessage('no_logs_message')}</h4>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <SlidingPanel
        type={'right'}
        isOpen={openPanel}
        noBackdrop={false}
        size={100}
      >
        <div className="bg_slide panel">
          <div className="row bb p-2 pl-4 g-0 align-items-center ">
            <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10">
              <h2 className="fw-bold mb-0 mt-1 ms-2 py-2">
                {selectedRow.Factory
                  ? selectedRow.Factory
                  : formatMessage('details')}
                {/* {formatMessage('details')} */}
              </h2>
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 close-icon-detail">
              <span title={formatMessage('close')}>
                <CloseSidePanelIcon closePanelHandler={closePanelHandler} />
              </span>
            </div>
          </div>
          <div className="group_detailsWrapper pb-3">
            <UserLogDetails selectedRowId={selectedRow.Id} />
          </div>
        </div>
      </SlidingPanel>
    </>
  );
};

export default FilterPopupHOC(observer(UserLogs));
